import {useTheme} from 'styled-components';
import * as css from './WindowFrame.css';
import Link from '../../../../component/link/Link';
import {Helper} from '@tickchak/react-share/app';
import {BLACK, LIGHT_GRAY} from '../../../../globalVariables/GlobalVariables';
import {WindowHeaderData} from './WindowFrame';

type WindowHeaderProps = {
    variant: 'event' | 'account';
    header: WindowHeaderData;
    onOpenExplain: () => void;
    onOpenArrived: () => void;
};

export default function WindowHeader({variant, header, onOpenExplain, onOpenArrived}: WindowHeaderProps) {
    const theme = useTheme() as {isDarkMode?: boolean};
    const {title, start, end, openLayout, link, explainComp, explainTitle, explainDataCy,
        howArrivedTitle, helper, helperTitle, helperDataCy} = header;

    const questionMark = helper
        ? <Helper size="large" bgColor={theme?.isDarkMode ? LIGHT_GRAY : BLACK} title={helperTitle} ariaLabel={helperTitle}
            data-cy={helperDataCy} content={<css.helperContent>{helper}</css.helperContent>}/>
        : explainComp && <css.questionIcon className='free-color' data-cy={explainDataCy} aria-label={explainTitle} onClick={onOpenExplain}>?</css.questionIcon>;

    return (
        <css.windowHeader openLayout={openLayout} $variant={variant === 'account' ? 'account' : 'event'}>
            {variant === 'account'
                ? <>
                    <css.title>{title}</css.title>
                    <css.actions>{start}{questionMark}</css.actions>
                </>
                : <>
                    {start}
                    {link && <Link href={link.href} isBlank={false}>
                        <css.linkButton onClick={link.onClick} className='free-color'>{link.text}</css.linkButton>
                    </Link>}
                    {header.howArrivedComp && <css.howArrivedText onClick={onOpenArrived}>{howArrivedTitle}</css.howArrivedText>}
                    {questionMark}
                    {end}
                </>}
        </css.windowHeader>
    );
}
